import {alias, createModelSchema, custom, deserialize, serialize, SKIP} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {Schema} from "@/common/Schema";

import {CurrencyKindModel} from "@/modules/redactor/models/currency/CurrencyKindModel";

export class ExchangeRate extends Cloneable {

    static schema() {
        return custom(
            (v) => {
                return v && !v.empty() ? serialize(ExchangeRate, v) : SKIP;
            },
            (v) => {
                return deserialize(ExchangeRate, v);
            }
        );
    }

    constructor() {
        super();
        this._kind = null;
        this._amount = 0;
    }

    get kind() {
        return this._kind;
    }

    set kind(value) {
        this._kind = value;
    }

    get amount() {
        return this._amount;
    }

    set amount(value) {
        this._amount = value;
    }

    valid() {

        if (!CurrencyKindModel.is(this.kind)) {
            return false;
        }

        if (Number.isNaN(this.amount) || this.amount <= 0) {
            return false;
        }

        return true;
    }

    empty() {
        return !this.kind || this.amount <= 0;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new ExchangeRate());
        } else if (target instanceof ExchangeRate) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(ExchangeRate, {
    _kind: alias("kind", CurrencyKindModel.schema()),
    _amount: alias("amount", Schema.primitive())
});

